<template>
    <div class="A4">
        <div class="row">
            <div class="col-sm-12">
                <div class="print-header">
                    <h4 class="text-center font-m">{{$t('expense_yearly')}}</h4>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <table class="table table-bordered table-hover table-sm no-bor">
                    <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                            <th>{{$t('year')}}</th>
                            <th class="text-right">{{$t('expense_on_cost')}}</th>
                            <th class="text-right">{{$t('expense_on_operation')}}</th>
                            <th class="text-right">{{$t('expense_on_sale_return')}}</th>
                            <th class="text-right">{{$t('total_amount')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret, index) in records" :key="index" :class="{'bg-info':ret.Year==year}">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ret.Year}}</td>
                            <td class="text-right">{{$money(ret.TotalCost)}}</td>
                            <td class="text-right">{{$money(ret.TotalOperation)}}</td>
                            <td class="text-right">{{$money(ret.TotalReturn)}}</td>
                            <td class="text-right">{{$money(ret.TotalAmount)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="2" class="text-right">{{$t('total')}}</th>
                            <th class="text-right">{{$money(summary.TotalCost)}}</th>
                            <th class="text-right">{{$money(summary.TotalOperation)}}</th>
                            <th class="text-right">{{$money(summary.TotalReturn)}}</th>
                            <th class="text-right">{{$money(summary.TotalAmount)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                year: new Date().getFullYear(),
                records: [],
                summary: {
                    TotalCost: 0,
                    TotalOperation: 0,
                    TotalReturn: 0,
                    TotalAmount: 0
                }
            }
        },
        created(){
            this.toList();
        },
        methods: {
            toList: function(){
                var loading = this.$loading.show();
                var req = {};
                this.$api().post('report/expense/yearly', req).then(res => {
                    if(this.$isValid(res)){
                        this.records = res.data.Json.Summaries;
                        this.calcualate();
                    }
                }).finally(function() { loading.hide(); });
            },
            calcualate(){
                var cost = 0;
                var opt = 0;
                var sret = 0;
                var total = 0;
                this.records.map(el => {
                    cost += el.TotalCost;
                    opt += el.TotalOperation;
                    sret += el.TotalReturn;
                    total += el.TotalAmount;
                });
                
                this.summary.TotalCost = cost;
                this.summary.TotalOperation = opt;
                this.summary.TotalReturn = sret;
                this.summary.TotalAmount = total;
            }
        }
    }
</script>
